export default {
  sm: `
  Download
  logo and BI guide
  `,
  md: `
  Download logo and BI guide
  `
};
